// src/utils/phone.js
export function maskPhone(phone) {
  if (!phone) return "";
  const raw = String(phone);

  // 이미 마스킹된 값은 하이픈만 정리 후 그대로 반환
  if (raw.includes("*")) return raw.replace(/[-\u2011]+/g, "-");

  // 숫자만 추출 (+82 → 0)
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("82")) digits = "0" + digits.slice(2);
  if (!digits) return raw;

  const H = "\u2011"; // 줄바꿈 방지 하이픈(보이는 건 '-')

  // 119/112 같은 3자리 서비스 번호는 그대로
  if (digits.length <= 3) return digits;

  // 15xx/16xx/18xx 대표번호 → 15xx-****
  if (/^(15|16|18)\d{6}$/.test(digits)) return `${digits.slice(0, 4)}${H}****`;

  // 02 지역번호
  if (digits.startsWith("02")) {
    const rest = digits.slice(2);
    if (!rest) return "02";
    if (rest.length <= 4) return `02${H}${"*".repeat(rest.length)}`;

    // 02는 3+3, 3+4, 4+4만 허용
    let mid, last;
    if (rest.length === 6) {        // 3+3
      mid = rest.slice(0, 3);
      last = rest.slice(3);         // 3
    } else if (rest.length === 7) { // 3+4
      mid = rest.slice(0, 3);
      last = rest.slice(3);         // 4
    } else if (rest.length === 8) { // 4+4
      mid = rest.slice(0, 4);
      last = rest.slice(4);         // 4
    } else {
      // 그 외 비표준 길이는 마지막 4자 고정으로 안전 처리
      mid  = rest.slice(0, Math.max(1, rest.length - 4));
      last = rest.slice(-4);
    }
    return `02${H}${"*".repeat(mid.length)}${H}${last}`;
  }

  // 나머지(031/032/... 지역번호 & 070/080 등)
  const prefix = digits.slice(0, 3);
  const rest   = digits.slice(3);
  if (!rest) return digits;

  // 010(휴대폰)은 기존 규칙 유지: 010-****-1234
  if (prefix === "010") {
    if (rest.length <= 4) return `010${H}${"*".repeat(rest.length)}`;
    const last = rest.slice(-4);
    return `010${H}****${H}${last}`;
  }

  // 지역번호(0XX): 3+3, 3+4, 4+4만 허용
  if (rest.length <= 3) {
    return `${prefix}${H}${"*".repeat(rest.length)}`;
  }

  let mid, last;
  if (rest.length === 6) {        // 3+3
    mid = rest.slice(0, 3);
    last = rest.slice(3);         // 3
  } else if (rest.length === 7) { // 3+4
    mid = rest.slice(0, 3);
    last = rest.slice(3);         // 4
  } else if (rest.length === 8) { // 4+4
    mid = rest.slice(0, 4);
    last = rest.slice(4);         // 4
  } else {
    // 비표준 길이는 마지막 4자 고정으로 안전 처리
    mid  = rest.slice(0, Math.max(1, rest.length - 4));
    last = rest.slice(-4);
  }

  return `${prefix}${H}${"*".repeat(mid.length)}${H}${last}`;
}
